import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
    WorkplaceInterface,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import {RootState} from '../../reducer';
import {
    FormControl, InputLabel, MenuItem,
    Pagination, Select,
    Table, TableBody,
    TableCell, TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import TextField from '@mui/material/TextField';
import {useNavigate} from 'react-router-dom';
import {MenuInterface} from "../../interface/menu.interface";
import Paper from "@mui/material/Paper";
import {BookApplicationInterface} from "../../interface/bookApplication.interface";
import {DateTime, Duration} from "luxon";
import Divider from "@mui/material/Divider";
import {BookApplicationDetail} from "../../interface/bookApplicationDetail.interface";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from '@mui/icons-material/Edit';
import BookApplicationDialog from "../dialog/BookApplicationDialog";

interface State {
    searchType: string,
    searchKeyword: string,
    totalCount: number,
    bookApplicationList: BookApplicationInterface[],
    bookApplicationDetailList: BookApplicationDetail[],
    selectedBookApplication: BookApplicationInterface,
    updateBookApplicationDetail: BookApplicationDetail,
    page: number,
    menu: MenuInterface,
}

const initState: State = {
    searchType: constance.searchType.name,
    searchKeyword: '',
    totalCount: 0,
    bookApplicationList: [],
    bookApplicationDetailList: [],
    selectedBookApplication: {
        _id: "", closed: "", date: "", workplace: ""
    },
    updateBookApplicationDetail: {
        _id: "", applicant: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""},
        author: "", createdAt: new Date(), name: "", publisher: "", usage: ""
    },
    page: 1,
    menu: {
        id: "",
        index: 0,
        name: "",
        path: "",
        subMenu: [],
        viewComment: false,
        placeholder: "",
        allowAdminReply: false,
        allowAdminPost: false,
    }
};

export default function BookApplication() {
    console.log('[BookApplication]');
    const [state, setState] = useState<State>(initState);
    const [openDialog, setOpenDialog] = useState(false);
    const commonData = useSelector((state: RootState) => state.commonData);
    const navigate = useNavigate();
    let {id, workplace, no, page, keyword, searchType} = common.getQuery();

    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);

    useEffect(() => {
        getList();
    }, [commonData.urlPath, page, id, workplace, keyword, searchType]);

    let bookNameRef: any = useRef();
    let authorRef: any = useRef();
    let publisherRef: any = useRef();

    let updateBookNameRef: any = useRef();
    let updateAuthorRef: any = useRef();
    let updatePublisherRef: any = useRef();

    /* 도서신청 리스트 */
    function getList() {
        axios.get(constance.api.getBookApplicationList, {
            params: {
                workplace: workplace,
                page: page,
            },
        }).then(value => {
            console.log(value);
            if (value.data.bookApplicationList.length > 0) {
                setState({
                    ...state,
                    selectedBookApplication: value.data.bookApplicationList[0],
                    bookApplicationDetailList: value.data.bookApplicationDetailList,
                    bookApplicationList: value.data.bookApplicationList,
                    page: page
                })
            }
        }).catch(reason => {
            console.log(reason);
        });
    }

    /* 사업장 변경 */
    function handleChangeWorkplace(workplace: WorkplaceInterface) {
        // 일반
        navigate(`${config.url.bookApplication}?workplace=${workplace.value}&page=${page}`);
    }

    /* 페이지 변경 */
    function changePagination(event: any, page: number) {
        if (page == 0) {
            page = event.target.value;
        }
        setState({
            ...state,
            page: page
        })
        navigate(`${config.url.bookApplication}?workplace=${workplace}&page=${page}`);
    }

    /* 신청세부 가져오기 */
    function handleGetBookApplicationDetail(bookApplication: BookApplicationInterface) {
        axios.get(constance.api.getBookApplicationDetailList, {
            params: {
                _id: bookApplication._id,
            },
        }).then(value => {
            console.log(value);
            setState({
                ...state,
                selectedBookApplication: bookApplication,
                bookApplicationDetailList: value.data.bookApplicationDetailList,
            })
            let menu = common.getMenuObject(id);
        }).catch(reason => {
            console.log(reason);
        });
    }

    /* 디테일 제목 생성 */
    function detailTitle() {
        if (state.selectedBookApplication._id == "") {
            return '';
        } else {
            let year = state.selectedBookApplication.date.substring(0, 4);
            let month = state.selectedBookApplication.date.substring(4);
            let title = `[${constance.workplaceNameMap[state.selectedBookApplication.workplace]}] ${year}년 ${month}월 도서지원 신청`;
            return title;
        }
    }

    /* 디테일 SubTitle 생성 */
    function detailSubTitle() {
        if (state.selectedBookApplication != null && state.selectedBookApplication._id == "") {
            return '';
        } else {
            let dateTime: any = DateTime.fromFormat(state.selectedBookApplication.date, 'yyyyMM');
            let startDate = new Date(dateTime.ts);
            let endDate = new Date(dateTime.ts);
            endDate.setDate(endDate.getDate() + 16);
            // endDate.setDate(endDate.getDate() - 1);
            let startText = DateTime.fromMillis(startDate.getTime()).toFormat('yyyy.MM.dd');
            let endText = DateTime.fromMillis(endDate.getTime()).toFormat('yyyy.MM.dd');
            let title = `신청가능기간 : ${startText} ~ ${endText}`;
            return title;
        }
    }

    function openBookApplication() {
        setOpenDialog(true)
    }

    /* 신청하기 */
    function saveBookApplication() {
        axios.post(constance.api.saveBookApplication, {
            params: {
                _id: state.selectedBookApplication._id,
                book: bookNameRef.current.value,
                author: authorRef.current.value,
                publisher: publisherRef.current.value,
            }
        }).then(value => {
            console.log(value);
            if (value.data.result) {
                common.alert('신청 성공', `[${bookNameRef.current.value}] ${value.data.message}`, 'info');
            } else {
                common.alert('신청 실패', `[${bookNameRef.current.value}] ${value.data.message}`, 'info')
            }
            setState({
                ...state,
                bookApplicationDetailList: value.data.bookApplicationDetailList
            })
            bookNameRef.current.value = '';
            authorRef.current.value = '';
            publisherRef.current.value = '';
        })
    }

    function updateApplication(value: BookApplicationDetail) {
        setState({
            ...state,
            updateBookApplicationDetail: value
        })
    }


    /* 요청 삭제 */
    function deleteApplication(value: BookApplicationDetail) {
        axios.post(constance.api.deleteBookApplication, {
            params: {
                _id: value._id,
            }
        }).then(value => {
            console.log(value);
            if (value.data.result) {
                common.alert('삭제 성공', value.data.message, 'info');
            } else {
                common.alert('삭제 실패', `[${bookNameRef.current.value}] ${value.data.message}`, 'info')
            }
            setState({
                ...state,
                bookApplicationDetailList: value.data.bookApplicationDetailList
            })
            bookNameRef.current.value = '';
            authorRef.current.value = '';
            publisherRef.current.value = '';
        })
    }

    /* 수정 버튼 클릭시 */
    function handleUpdateBookApplicationDetail() {
        axios.post(constance.api.updateBookApplication, {
            params: {
                _id: state.updateBookApplicationDetail._id,
                book: updateBookNameRef.current.value,
                author: updateAuthorRef.current.value,
                publisher: updatePublisherRef.current.value,
            }
        }).then(value => {
            console.log(value);
            if (value.data.result) {
                common.alert('수정 성공', `[${updateBookNameRef.current.value}] ${value.data.message}`, 'info');
            } else {
                common.alert('수정 실패', `[${updateBookNameRef.current.value}] ${value.data.message}`, 'info')
            }
            setState({
                ...state,
                updateBookApplicationDetail: {
                    _id: "",
                    applicant: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""},
                    author: "",
                    createdAt: new Date(),
                    name: "",
                    publisher: "",
                    usage: ""
                },
                bookApplicationDetailList: value.data.bookApplicationDetailList
            })
            updateBookNameRef.current.value = '';
            updateAuthorRef.current.value = '';
            updatePublisherRef.current.value = '';
        })
    }

    /* 업데이트 아이콘 버튼 클릭시 */
    function bookApplicationDetailBox(value: BookApplicationDetail) {
        if (value._id == state.updateBookApplicationDetail._id) {
            return (
                <Stack sx={{display: 'flex', alignItems: 'center'}}>
                    <TextField inputRef={updateBookNameRef}
                               size={"small"}
                               sx={{mt: 1, width: 1}}
                               label={'도서명'}
                               focused
                               defaultValue={value.name}/>
                    <Box sx={{width: 1, display: 'flex', mt: 2}}>
                        <TextField inputRef={updateAuthorRef}
                                   size={"small"}
                                   sx={{mr: 1}}
                                   label={'저자'}
                                   focused
                                   defaultValue={value.author}/>
                        <TextField inputRef={updatePublisherRef}
                                   size={"small"}
                                   sx={{ml: 1}}
                                   label={'출판사'}
                                   focused
                                   defaultValue={value.publisher}/>
                    </Box>
                    <Button onClick={() => handleUpdateBookApplicationDetail()}
                            sx={{mt: 1, mb: 1, width: 100}}
                            color={"neutral"}
                            variant={"contained"}>
                        <Typography>수정</Typography>
                    </Button>
                </Stack>
            );
        } else {
            return (
                <Stack sx={{display: 'flex', alignItems: 'center'}}>
                    <TextField sx={{mt: 1, width: 1}}
                               size={"small"}
                               label={'도서명'}
                               InputProps={{
                                   readOnly: true,
                               }}
                               value={value.name}/>
                    <Box sx={{width: 1, display: 'flex', mt: 2}}>
                        <TextField sx={{mr: 1}}
                                   size={"small"}
                                   label={'저자'}
                                   InputProps={{
                                       readOnly: true,
                                   }}
                                   value={value.author}/>
                        <TextField sx={{ml: 1}}
                                   size={"small"}
                                   label={'출판사'}
                                   InputProps={{
                                       readOnly: true,
                                   }}
                                   value={value.publisher}/>
                    </Box>
                </Stack>
            )
            // return `${value.name} / ${value.author} / ${value.publisher}`;
        }

    }

    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    {/* 사업장 선택이 있는 게시판일 경우 => 사업장 선택 버튼 생성 */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center', alignItems: 'center'
                    }}>
                        {
                            Object.keys(constance.workplace).map((key, index) => {
                                const workplaceObject: any = constance.workplace;
                                const _workplace: WorkplaceInterface = workplaceObject[key];
                                return (
                                    <Stack key={index} sx={{position: 'relative'}}>
                                        <Button variant={workplace === _workplace.value ? 'contained' : 'outlined'}
                                                color={'error'}
                                                onClick={() => handleChangeWorkplace(_workplace)}
                                                sx={{
                                                    mr: 0.5,
                                                    background: workplace === _workplace.value ? '#d32f2f' : 'var(--scc-surface)'
                                                }}>
                                            <Typography variant={"subtitle1"}>
                                                {_workplace.name}
                                            </Typography>
                                        </Button>
                                    </Stack>
                                );
                            })
                        }
                    </Box>

                    {/* Content */}
                    <Box sx={{display: 'flex', width: 1, mt: 2, position: 'relative', flexWrap: 'wrap'}}>

                        {/* 좌측 용인 도서지원 신청 현황 */}
                        <Stack sx={{
                            display: 'flex',
                            width: {xs: 1, sm: 1, md: 0.5},
                            p: {xs: 0, sm: 0, md: 1},
                            pr: {xs: 0, sm: 0, md: 2}
                        }}>
                            <Paper sx={{
                                width: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                mb: 2,
                            }}>
                                <Stack sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2}}>
                                    <Typography variant={"h6"}>{"도서지원 신청 현황"}</Typography>
                                    <Typography variant={"subtitle1"}>{"- 사업장 확인 후 신청 -"}</Typography>
                                </Stack>

                                <Divider/>
                                <TableContainer component={Paper}>
                                    <Table sx={{minWidth: 300}} size={'medium'} aria-label="a dense table">
                                        <TableHead>
                                            <TableRow sx={{'th': {padding: '16px'}, width: 1}}>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                state.bookApplicationList.map((bookApplication, index) => {
                                                    let year = bookApplication.date.substring(0, 4);
                                                    let month = bookApplication.date.substring(4);
                                                    let countDown = '';
                                                    let title = `${year}년 ${month}월 도서지원`;
                                                    if (bookApplication.closed == 'N') {
                                                        let date: any = DateTime.fromFormat(bookApplication.date, 'yyyyMM');
                                                        let dateValue = new Date(date.ts);
                                                        dateValue.setDate(dateValue.getDate() + 17); // 해당 월 17일 마감
                                                        let diff = DateTime.fromMillis(dateValue.getTime()).diff(DateTime.local());
                                                        countDown = Duration.fromObject(diff.toObject()).toFormat('dd일 hh시간') + ' 남음';
                                                        console.log(date);
                                                    } else {
                                                        countDown = '-';
                                                    }
                                                    return <TableRow
                                                        onClick={() => handleGetBookApplicationDetail(bookApplication)}
                                                        sx={{
                                                            width: 1,
                                                            '&:last-child td, &:last-child th': {border: 0},
                                                            'td': {padding: '8px'},
                                                            ':hover': {
                                                                background: styles.tableHoverColor,
                                                            },
                                                            backgroundColor: bookApplication._id == state.selectedBookApplication._id ? '#ffe3e3' : 'inherit',
                                                            cursor: 'pointer',
                                                            height: 50,
                                                            transition: styles.transition,
                                                        }}
                                                    >
                                                        {/* 게시글 번호 */}
                                                        <TableCell align="center" sx={{minWidth: 55}}>
                                                            <Typography variant={fontSize}
                                                                        color={bookApplication.closed == 'Y' ? 'inherit' : 'red'}>
                                                                {bookApplication.closed == 'Y' ? "종료" : "진행 중"}
                                                            </Typography>

                                                        </TableCell>

                                                        {/* 사업장 */}
                                                        <TableCell align="center" sx={{minWidth: 45}}>
                                                            <Typography variant={fontSize}>
                                                                {constance.workplaceNameMap[bookApplication.workplace]}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* 제목 */}
                                                        <TableCell align="center">
                                                            <Typography variant={fontSize}>
                                                                {title}
                                                            </Typography>
                                                        </TableCell>

                                                        {/* 저자 */}
                                                        <TableCell align="center">
                                                            <Typography variant={fontSize}>
                                                                {countDown}
                                                            </Typography>
                                                        </TableCell>

                                                    </TableRow>
                                                })
                                            }

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>


                            {/* 페이징 */}
                            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2, mb: 1}}>
                                <Stack spacing={1}>
                                    <Pagination
                                        count={Math.ceil(state.totalCount / 10)}
                                        variant="outlined"
                                        page={state.page}
                                        shape={'rounded'}
                                        boundaryCount={isMobile ? 0 : 2}
                                        onChange={changePagination}/>
                                </Stack>
                                <FormControl sx={{ml: 2}}>
                                    <InputLabel>페이지</InputLabel>
                                    <Select
                                        value={state.page}
                                        label="페이지"
                                        size={"small"}
                                        onChange={(event) => changePagination(event, 0)}
                                    >
                                        {
                                            new Array(Math.ceil(state.totalCount / 10)).fill(0).map((value, index) => {
                                                return <MenuItem value={index + 1}>{index + 1}</MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Box>
                        </Stack>

                        {/* 좌측 용인 도서지원 신청 현황 */}
                        <Stack sx={{display: 'flex', width: {xs: 1, sm: 1, md: 0.5}, p: {xs: 0, sm: 0, md: 1}}}>
                            <Paper sx={{
                                width: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                mb: 2,
                            }}>
                                <Stack sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alighItems: 'center',
                                    p: {xs: 1, sm: 1, md: 2}
                                }}>
                                    <Typography variant={"h6"} align={"center"}>{detailTitle()}</Typography>
                                    <Typography variant={"subtitle1"} align={"center"}
                                                sx={{mt: 1}}>{detailSubTitle()}</Typography>
                                    <Divider sx={{mt: 1}}/>
                                    <Stack sx={{
                                        width: 1,
                                        minHeight: 300,
                                        overflowY: 'scroll',
                                        height: `calc(100vh - 500px)`
                                    }}>

                                        {/* 도서지원 신청 상세 페이지 */}
                                        {
                                            state.bookApplicationDetailList.map((value, index) => {
                                                let backgroundColor = index % 2 == 0 ? 'inherit' : '#f3f0f0';
                                                return (
                                                    <Stack key={index} sx={{
                                                        borderBottom: styles.border,
                                                        p: 1,
                                                        backgroundColor: backgroundColor
                                                    }}>
                                                        <Box sx={{display: 'flex',}}>
                                                            <Typography variant={fontSize} sx={{width: 0.5}}>
                                                                {`${value.applicant.departmentName} ${value.applicant.name}`}
                                                            </Typography>
                                                            <Typography variant={fontSize} align={"right"}
                                                                        sx={{width: 0.5}}>
                                                                {`${common.getTimeFormat(value.createdAt)}`}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{display: 'flex'}}>
                                                            <Typography variant={fontSize} sx={{width: 0.9, p: 1}}>
                                                                {
                                                                    bookApplicationDetailBox(value)
                                                                }
                                                            </Typography>

                                                            <Box sx={{
                                                                display: value._id == state.updateBookApplicationDetail._id ? 'none' : 'flex',
                                                                width: 0.1,
                                                                justifyContent: 'flex-end'
                                                            }}>
                                                                {
                                                                    value.applicant._id == commonData.user._id ?
                                                                        <>
                                                                            <EditIcon
                                                                                onClick={() => updateApplication(value)}
                                                                                sx={{
                                                                                    cursor: 'pointer',
                                                                                    color: styles.editColor
                                                                                }}/>
                                                                            <DeleteForeverIcon
                                                                                onClick={() => deleteApplication(value)}
                                                                                sx={{
                                                                                    cursor: 'pointer',
                                                                                    color: styles.deleteColor
                                                                                }}/>
                                                                        </>

                                                                        :
                                                                        ''
                                                                }

                                                            </Box>
                                                        </Box>
                                                    </Stack>
                                                )
                                            })
                                        }
                                    </Stack>
                                </Stack>
                            </Paper>
                            <Stack>
                                <TextField inputRef={bookNameRef}
                                           label={"도서명"}
                                           disabled={state.selectedBookApplication.closed == 'Y'}
                                           sx={{backgroundColor: 'var(--scc-surface)'}}/>
                                <Box sx={{display: 'flex', width: 1, mt: 1}}>
                                    <TextField inputRef={authorRef}
                                               label={"저자"}
                                               disabled={state.selectedBookApplication.closed == 'Y'}
                                               sx={{width: 0.5, mr: 1, backgroundColor: 'var(--scc-surface)'}}/>
                                    <TextField inputRef={publisherRef}
                                               label={"출판사"}
                                               disabled={state.selectedBookApplication.closed == 'Y'}
                                               sx={{width: 0.5, backgroundColor: 'var(--scc-surface)'}}/>
                                </Box>

                                <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <Button sx={{mt: 2}}
                                            variant={'outlined'}
                                            onClick={openBookApplication}
                                            disabled={state.selectedBookApplication.closed == 'Y'}
                                            color={'whiteOutlined'}>
                                        <Typography>{'신청하기'}</Typography>
                                    </Button>
                                </Box>
                            </Stack>
                        </Stack>
                    </Box>


                </Stack>

                <BookApplicationDialog open={openDialog} setOpen={setOpenDialog} saveBookApplication={saveBookApplication}/>
            </Box>
        </>
    );
}
